module.exports = __webpack_public_path__ + "media/hyper/fonts/unicons-ca6ba1354c470b06df5d56e4afa3aae3.eot";